import React from 'react';
import { Route } from 'react-router-dom';

const PrivateRoute = ({ component: ComposedComponent, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props => {
                return (
                    <ComposedComponent {...props} />
                );
            }}
        />
    );
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/auth/PrivateRoute.js